function cmgShareArticle() {
  const btn = document.getElementById('cma-share-btn');
  if (!btn) return;

  const shareTitle = btn.dataset.shareTitle || document.title;
  const copiedText = btn.dataset.shareCopiedText || 'Copied';

  if (navigator.share) {
    navigator.share({
      title: shareTitle,
      url: window.location.href
    });
    return;
  }

  navigator.clipboard.writeText(window.location.href).then(function() {
    const original = btn.innerHTML;
    btn.innerHTML = copiedText;
    setTimeout(function() {
      btn.innerHTML = original;
    }, 2000);
  });
}
